import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"

import Grid from "../shared/grid"
import Link from "../shared/link"
import { UIContext } from "../shared/layout"
import {
  Background,
  StyledFluid,
  DetailsWrapper,
  Title,
  Body,
  linkStyle,
} from "./analytics.style"

const Analytics = () => {
  const { state: UIState } = useContext(UIContext)
  const { analyticsImage, analyticsMobileImage } = useStaticQuery(graphql`
    query {
      analyticsImage: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/analytics_dashboard_desk.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      analyticsMobileImage: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/analytics_dashboard_mobile.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <Background>
      <Grid>
        <StyledFluid
          fluid={
            UIState.breakpoint === "sm"
              ? analyticsMobileImage.childImageSharp.fluid
              : analyticsImage.childImageSharp.fluid
          }
          alt="A laptop showing a dashboard of analytics data."
          imgStyle={{ objectFit: "contain" }}
        />
        <DetailsWrapper>
          <Title>Analytics Dashboard</Title>
          <Body>
            Understand what your visitors are searching for and where they are
            travelling to. Collect and visualize trends at your venue.
          </Body>
          <Link href="/mapping/analytics/" styleModifier={linkStyle}>
            Explore Analytics
          </Link>
        </DetailsWrapper>
      </Grid>
    </Background>
  )
}

export default Analytics
